module.exports = __webpack_public_path__ + "static/media/login.97afdb33.PNG";